import type * as udsTokens from '@sunwebgroup/design-tokens/sunweb-sun-uds'
import { createContext, type PropsWithChildren, use } from 'react'

export type UdsTokens = typeof udsTokens

const UdsTokensContext = createContext<UdsTokens | null>(null)

export function UdsTokensProvider({ tokens, children }: PropsWithChildren<{ tokens: UdsTokens }>) {
  return <UdsTokensContext value={tokens}>{children}</UdsTokensContext>
}

export function useUdsToken<T>(tokenName: keyof UdsTokens): T {
  const tokens = use(UdsTokensContext)
  if (!tokens) {
    throw new Error('useUdsToken must be used within a UdsTokensProvider')
  }
  return tokens[tokenName] as T
}
